import React from 'react';
import { Typography, Card, CardContent, CardMedia, CardActionArea, IconButton, makeStyles } from '@material-ui/core';
import { useLocation, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { addProductToCart, removeProductFromCart } from '../../../actions/cart';
import { resize } from '../../../utils/images';
import { buildUrlWithParam, getIconButton } from '../../../helpers/utils';
import styles from './Product.styles';

const useStyles = makeStyles(styles);

const Product = ({ product }) => {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const inCart = useSelector(state => state.cart.items.some(item => item.product.id === product.id));

  const handleToggle = () => dispatch((inCart ? removeProductFromCart : addProductToCart)(product));

  const [imgSrc, imgAlt] = getIconButton(inCart);

  const urlToOpen = buildUrlWithParam(location, 'details', product.id);

  return (
    <Card className={classes.root}>
      <CardActionArea component={Link} replace to={urlToOpen} className={classes.actionArea}>
        <CardMedia image={resize(product.img, 233, 257)} title={product.name} className={classes.image} />
      </CardActionArea>
      <CardContent className={classes.content}>
        <div className={classes.details}>
          <Typography className={classes.title}>{product.name}</Typography>
          <Typography className={classes.price}>
            Starting at <strong>{product.price}</strong>
          </Typography>
        </div>
        <IconButton color="primary" aria-label="toggle-product" className={classes.button} onClick={handleToggle}>
          <img src={imgSrc} alt={imgAlt} />
        </IconButton>
      </CardContent>
    </Card>
  );
};

export default Product;
